// extracted by mini-css-extract-plugin
module.exports = {"tableHead":"Table_tableHead__2G2jx","bigColWidth":"Table_bigColWidth__wbsed","biggerColWidth":"Table_biggerColWidth__24Lr9","row":"Table_row__U060p","col":"Table_col__3XjdB"};